import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/',
    component: TabsPage,
    children: [
      {
        path: '/',
        redirect: '/login'
      },
      {
        path: '/login',
        component: () => import('@/views/LoginPage.vue')
      },
      // {
      //   path: 'tab2',
      //   component: () => import('@/views/Tab2Page.vue')
      // },
      // {
      //   path: 'tab3',
      //   component: () => import('@/views/Tab3Page.vue')
      // }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
